/* eslint-disable react-hooks/exhaustive-deps */

// React Imports
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Component Imports
import BankDetails from "../../../../components/_utils/AccountCreationComponents/BankDetails";
import ConfidentialCard from "../../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import ConfirmBtnAccCreation from "../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";

// Utils Imports
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import TEXT from "../../../../utils/globalText";

import ICONS from "../../../../assets/Icons";
import ActiveInactiveAssociatePopup from "../../../../components/_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../components/_utils/CommonLayout";

const CreateBank = ({
  setBankLookupNext,
  bankLookupNext,
  nextButtonEnabled,
  BenEnableNextButton,
  payload,
  setPayload,
  activeStep,
  setBankIsArchived,
  setBankIsApproved,
  setBankIsDennied,
  setBankIsPending,
  hideBankBlock,
  setBankHideBlock,
  isButtonDisabled,
  setBankUserInfo,
  bankVerificationStatus,
  setBankVerificationStatus,
  isIFSCValid,
  isBankError,
  virtualAccount,
  setVirtualAccount,
  previousId,
  setPreviousBankNo,
  manualVirtualAccount,
  setManualVirtualAccount,
  ownerAccIfscData,
  ownerAccIfscError,
  type,
}) => {
  const dropDownOptions = [
    "Reimbursement account",
    "Field force account",
    "Beneficiary account",
    "Tax account",
  ];

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(dropDownOptions[0]);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [isCreateAccount, setIsCreateAccount] = useState(false);
  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );
  const beneLookLoading = useSelector(
    (state) => state.beneAllVerification.beneLookLoading,
  );

  const { ownerAccIfscLoading } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const ifscData = ownerAccIfscData?.ifsc_details?.[0];

  const accounts = benebankLookData?.beneficiary_accounts || [];

  const shouldShowNoAssociatedMsg =
    !beneLookLoading &&
    bankVerificationStatus === true &&
    !virtualAccount &&
    payload.bank_account?.length >= GlobalConfiguration?.accountnormalLength &&
    payload.ifsc_code?.length === GlobalConfiguration?.ifscLength &&
    accounts.length === GlobalConfiguration?.lengthCheckZero;

  const details =
    !beneLookLoading &&
    benebankLookData?.status === undefined &&
    !isBankError &&
    isIFSCValid &&
    !virtualAccount;

  useEffect(() => {
    benebankLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [benebankLookData]);

  useEffect(() => {
    const foundAccount = benebankLookData?.beneficiary_accounts?.find((val) => {
      if (
        payload?.panNumber === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.ifsc_code === val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        setIsCreateAccount(true);

        return true;
      }
      return false;
    });

    if (foundAccount) {
      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : foundAccount?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );
      setAccActiveInactiveState(
        foundAccount?.approval_status === "rejected" ||
          foundAccount?.approval_status === "blocked" ||
          foundAccount?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    }

    if (!foundAccount) {
      setIsBankLinkedAccount(false);
      setIsCreateAccount(false);
    }
  }, [benebankLookData, payload]);

  return (
    <>
      <div className="flex flex-col gap-y-gap-md px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full">
            {hideBankBlock && !isBankError && !virtualAccount ? (
              <div className="bene_block_message_text">
                <img
                  src={
                    "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  }
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : isBankLinkedAccount && isIFSCValid ? (
              <div className="bank_new_message_text_block_nonarchive">
                <img
                  src="https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>
                  Looks like this bank account is already linked to your PAN.
                  Please update either the bank details or your PAN to proceed.
                </p>
              </div>
            ) : null}
            {virtualAccount && isIFSCValid ? (
              <>
                <div className="flex flex-row gap-x-gap-sm bg-emphasis p-padding-md rounded-border-radius-md mb-margin-md">
                  <img
                    src={ICONS.VIRTUAL_ACCOUNT}
                    alt="Virtual Account"
                    className="w-icon-md h-icon-md"
                  />
                  <div className="flex flex-col gap-y-gap-sm">
                    <p className="text-font-sm text-text-primary font-semibold">
                      Virtual Account Detected
                    </p>
                    <ul className="flex flex-col gap-y-gap-sm list-disc list-inside ml-margin-xs">
                      <li className="text-font-xs text-text-primary font-normal">
                        Account could not be verified as it is virtual account.
                      </li>
                      <li className="text-font-xs text-text-primary font-normal">
                        Please self verify and proceed with caution.
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            ) : null}
            <div
              className={`h-fit w-full lg:max-w-[var(--create-box-width)] ${type === "switch_account" ? "opacity-light-opacity" : "opacity-base-opacity"}`}
            >
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={BenEnableNextButton}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={ifscData}
                ownerAccIfscError={ownerAccIfscError}
                ownerAccIfscLoading={ownerAccIfscLoading}
                type={type}
              />
            </div>
          </div>
          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)]`}
          >
            {isBankError === true &&
              ownerAccIfscError === false &&
              !ownerAccIfscLoading && (
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                  note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  onToggle={() => {
                    const nextState = !manualVirtualAccount;
                    setManualVirtualAccount(nextState);
                    setBankVerificationStatus(!bankVerificationStatus);
                    setPayload({
                      ...payload,
                      virtual: nextState ? true : false,
                    });
                  }}
                />
              )}

            {shouldShowNoAssociatedMsg &&
              !isBankError &&
              !manualVirtualAccount && (
                <div className=" bg-primary-card rounded-border-radius-md p-padding-md flex flex-col items-center">
                  <div className="flex flex-col gap-gap-sm w-width-full h-height-full">
                    <p className=" text-text-primary text-font-md font-semibold">
                      Associated Accounts
                    </p>

                    <div className="flex flex-col gap-y-gap-xs">
                      <p className="text-font-sm text-text-primary font-semibold">
                        No associated accounts found
                      </p>
                      <p className="text-font-xs text-text-secondary font-normal">
                        There are no existing accounts that are associated with
                        the bank details provided. You can proceed to create a
                        new account.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            <ConfirmBtnAccCreation
              type="bank"
              status={benebankLookData?.status}
              isIFSCValid={isIFSCValid}
              isBankError={isBankError}
              lookupNext={bankLookupNext}
              isButtonDisabled={isBankLinkedAccount && isIFSCValid}
              nextButtonEnabled={nextButtonEnabled}
              handleClick={() => {
                if (!isButtonDisabled && !isCreateAccount) {
                  setIsCreateAccount(false);
                  setBankIsApproved(false);
                  setBankLookupNext(true);
                  setBankIsArchived(false);
                  setBankIsDennied(false);
                  setBankIsPending(false);
                  setBankHideBlock(false);
                  if (bankLookupNext) {
                    BenEnableNextButton(true);
                  } else {
                    BenEnableNextButton(false);
                  }
                  if (bankLookupNext) {
                    setBankLookupNext(false);
                  }
                }
              }}
            />

            <div
              style={{
                display:
                  benebankLookData?.status && isIFSCValid && !isBankError
                    ? "block"
                    : "none",
              }}
            >
              <ActiveInactiveAssociatePopup
                flow={
                  isBankLinkedAccount && isIFSCValid
                    ? "Existing"
                    : details
                      ? "notFound"
                      : "Bank"
                }
                dropDownOptions={dropDownOptions}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.panNumber}
                accActiveInactiveState={accActiveInactiveState}
                setAccActiveInactiveState={setAccActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default CreateBank;
